import { type AdType } from './types'

// Native (AppLovin) ad static units — used once the native SDK ships (Android ≥ 1.3.0 / iOS ≥ 1.1.6).
const ANDROID_APPLOVIN_STATIC_AD_UNITS: Partial<Record<AdType, string>> = {
    sidebar: '10463e351bd291e4',
    sidebar_bottom: '2c806b2ff068c4b0',
    sidebar_bottom_fullscreen: '10463e351bd291e4',
    sidebar_fullscreen: '2c806b2ff068c4b0',
    leaderboard: '7f01b3ab73b34ca5',
    leaderboard_rest: '7f01b3ab73b34ca5',
    sticky_mobile: '7f01b3ab73b34ca5',
    sticky_mobile_non_game_page: '7f01b3ab73b34ca5',
    sticky_tablet: '7f01b3ab73b34ca5',
    widget_sticky_tablet: '7f01b3ab73b34ca5',
    widget_sticky_mobile: '7f01b3ab73b34ca5',
}

const IOS_APPLOVIN_STATIC_AD_UNITS: Partial<Record<AdType, string>> = {
    sidebar: 'd1122d34d7bf9788',
    sidebar_bottom: 'eb4462a34a3ebeb0',
    sidebar_bottom_fullscreen: 'd1122d34d7bf9788',
    sidebar_fullscreen: 'eb4462a34a3ebeb0',
    leaderboard: 'e0376ee33bf46aed',
    leaderboard_rest: 'e0376ee33bf46aed',
    sticky_mobile: 'e0376ee33bf46aed',
    sticky_mobile_non_game_page: 'e0376ee33bf46aed',
    sticky_tablet: 'e0376ee33bf46aed',
    widget_sticky_tablet: 'e0376ee33bf46aed',
    widget_sticky_mobile: 'e0376ee33bf46aed',
}

// Native (AppLovin) ad units — used once the native SDK ships (Android ≥ 1.1.09 / iOS ≥ 1.1.3).
const ANDROID_APPLOVIN_AD_UNITS: Partial<Record<AdType, string>> = {
    interstitial: 'adc0a523dde2c2f1',
    rewarded: 'd0ef11af6f54f0fb',
}
const IOS_APPLOVIN_AD_UNITS: Partial<Record<AdType, string>> = {
    interstitial: 'da96af9802e81f8f',
    rewarded: '23193cc48219498c',
}

// GAM fallback ad units for older app versions without the native SDK.
const ANDROID_GAM_AD_UNITS: Partial<Record<AdType, string>> = {
    interstitial: '/23211928466/interstitial_android',
    interstitial_preroll: '/23211928466/interstitial_preroll_android',
    rewarded: '/23211928466/rewarded_android',
}
const IOS_GAM_AD_UNITS: Partial<Record<AdType, string>> = {
    interstitial: '/23211928466/interstitial_ios',
    interstitial_preroll: '/23211928466/interstitial_preroll_ios',
    rewarded: '/23211928466/rewarded_ios',
}
const TEST_GAM_AD_UNITS: Partial<Record<AdType, string>> = {
    interstitial: '/21775744923/example/interstitial',
    interstitial_preroll: '/21775744923/example/interstitial',
    rewarded: '/21775744923/example/rewarded',
}

export function getAppAdUnits({
    isVersionAtLeast,
    isNativeBannersEnabled,
}: {
    isVersionAtLeast: (minVersions: { ios?: string; android?: string }) => boolean
    isNativeBannersEnabled: boolean
}) {
    const hasApplovinSdk = isVersionAtLeast({ ios: '1.1.3', android: '1.1.09' })

    const androidNativeBannerAdUnits = isNativeBannersEnabled ? ANDROID_APPLOVIN_STATIC_AD_UNITS : {}
    const iosNativeBannerAdUnits = isNativeBannersEnabled ? IOS_APPLOVIN_STATIC_AD_UNITS : {}

    const androidNativeAdUnits = hasApplovinSdk
        ? { ...ANDROID_APPLOVIN_AD_UNITS, ...androidNativeBannerAdUnits }
        : ANDROID_GAM_AD_UNITS
    const iosNativeAdUnits = hasApplovinSdk ? { ...IOS_APPLOVIN_AD_UNITS, ...iosNativeBannerAdUnits } : IOS_GAM_AD_UNITS
    const androidTestNativeAdUnits = hasApplovinSdk
        ? { ...ANDROID_APPLOVIN_AD_UNITS, ...androidNativeBannerAdUnits }
        : TEST_GAM_AD_UNITS
    const iosTestNativeAdUnits = hasApplovinSdk
        ? { ...IOS_APPLOVIN_AD_UNITS, ...iosNativeBannerAdUnits }
        : TEST_GAM_AD_UNITS

    return {
        androidNativeAdUnits,
        iosNativeAdUnits,
        androidTestNativeAdUnits,
        iosTestNativeAdUnits,
    }
}
